// src/constants.ts
import Logo from "@/assets/clip-logo.png";

export const LOGO_URL = Logo;
export const WHATSAPP_NUMBER = "447593288804";
export const SUPPORT_EMAIL = "info@cobblestoneinteractive.com"; // Keeping email as fallback or option
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;